var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F\\xFCllung",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320,320a16,16,0,0,0-16,16v40a24,24,0,0,1-24,24H120a24,24,0,0,1-24-24V136a24,24,0,0,1,24-24H272c15.25,0,32,12.56,32,24v40a16,16,0,0,0,32,0V136c0-15.1-8-30-21.85-40.88C301.89,85.51,286.52,80,272,80H120a56.06,56.06,0,0,0-56,56V376a56.06,56.06,0,0,0,56,56H280a56.06,56.06,0,0,0,56-56V336A16,16,0,0,0,320,320Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.31,244.69l-80-80a16,16,0,0,0-22.62,22.62L425.37,240H192a16,16,0,0,0,0,32H425.37l-52.68,52.69a16,16,0,1,0,22.62,22.62l80-80A16,16,0,0,0,475.31,244.69Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon-sign-out.ca10e120.svg";
export { ForwardRef as ReactComponent };